module.exports = __webpack_public_path__ + "img/Stages-Sessions.812c5bbc.png";